import React from 'react';
import { SiTerraform } from 'react-icons/si';
import './TerraformIcon.css';

/** Terraform brand purple */
const TERRAFORM_PURPLE = '#7B42BC';

const TerraformIcon: React.FC<{ className?: string; size?: number }> = ({
  className = '',
  size = 24,
}) => (
  <span className={`terraform-icon ${className}`.trim()} aria-hidden>
    <SiTerraform size={size} color={TERRAFORM_PURPLE} />
  </span>
);

export default TerraformIcon;
